import { InstallmentReportRow } from '../../../../../api/types/reports/accountant/installment.type';

export function createInstallmentsExcelData(
  rows: InstallmentReportRow[],
  formatDate: (date: any) => string,
  getStatusLabel: (status: InstallmentReportRow['status']) => string,
  formatClearanceStatusCode: (clearanceStatusCode: string | null) => string,
): string[][] {
  return [
    [
      'שלוחה',
      'שם משלם',
      'סכום כולל',
      'מספר תשלומים',
      'תשלום מספר',
      'סכום תשלום',
      'תאריך לתשלום',
      'תאריך תשלום בפועל',
      'תאריך תשלום ראשון',
      'יום חיוב בחודש',
      'סטטוס',
      'סטטוס סליקה',
    ],
    ...rows.map((row) => {
      const branchName = (row as any).branchName ?? '';
      const payerName = `${row.firstName ?? ''} ${row.lastName ?? ''}`.trim();
      const totalAmount =
        typeof row.totalAmount === 'number' ? String(row.totalAmount) : '';
      const numberOfInstallments =
        typeof row.numberOfInstallments === 'number'
          ? String(row.numberOfInstallments)
          : '';
      const installmentNumber =
        typeof row.installmentNumber === 'number'
          ? String(row.installmentNumber)
          : '';
      const amount = typeof row.amount === 'number' ? String(row.amount) : '';
      const dueDate = row.dueDate ? formatDate(row.dueDate) : '';
      const paidAt = row.paidAt ? formatDate(row.paidAt) : '';
      const firstPaymentDate = row.firstPaymentDate
        ? formatDate(row.firstPaymentDate)
        : '';
      const paymentDayOfMonth =
        typeof row.paymentDayOfMonth === 'number'
          ? String(row.paymentDayOfMonth)
          : '';
      const status = getStatusLabel(row.status);
      const clearanceStatus = formatClearanceStatusCode(
        row.clearanceStatusCode ?? null,
      );

      return [
        branchName,
        payerName,
        totalAmount,
        numberOfInstallments,
        installmentNumber,
        amount,
        dueDate,
        paidAt,
        firstPaymentDate,
        paymentDayOfMonth,
        status,
        clearanceStatus,
      ];
    }),
  ];
}
